import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../components/ui/button'
import { NavBar } from '../components/NavBar'

export function HomePage() {
  return (
    <div className="flex min-h-screen flex-col bg-stone-900 text-stone-100">
      <NavBar />

      <main className="flex flex-1 flex-col items-center justify-center gap-8 px-6 py-16 text-center">
        <div className="max-w-md">
          <h1 className="font-serif text-4xl font-semibold leading-tight tracking-tight">
            Stand closer to Shakespeare.
          </h1>
          <p className="mt-3 text-stone-400">
            Track, rate, and share every Shakespeare performance you see.
          </p>
        </div>

        <Link to="/log">
          <Button className="bg-red-900 px-8 py-3 text-base font-semibold text-stone-100 hover:bg-red-800">
            Log a performance
          </Button>
        </Link>

        <nav className="flex flex-wrap justify-center gap-6 text-sm text-stone-500">
          <Link to="/plays" className="transition-colors hover:text-amber-400">
            Plays →
          </Link>
          <Link to="/diary" className="transition-colors hover:text-amber-400">
            Diary →
          </Link>
          <Link to="/want-to-watch" className="transition-colors hover:text-amber-400">
            Want to watch →
          </Link>
          <Link to="/profile" className="transition-colors hover:text-amber-400">
            Profile →
          </Link>
        </nav>
      </main>
    </div>
  )
}
